<!--
@Create By Tim For 19/08/13
@底部组件
-->
<template>
  <div class="Foot">
    <div class="auto">
      <span>Copyright © 2018-2020 ICP备11018032号 </span>
      <span>
        <a href="#">联系我们</a> |
        <a href="#">帮助中心</a> |
        <a href="#">友情链接</a>

      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Foot',
  data() {
    return {

    }
  },
}
</script>

<style scoped>
.Foot {
  background: #fff;
  border-top: 1px solid #d8d8d8;
}

.Foot .auto {
  padding: 0 20px;
  width: 1440px;
  margin: 0 auto;
  height: 76px;
  line-height: 77px;
  font-size: 14px;
  color: #000;
}

.auto span:nth-child(1) {
  float: left;
}

.auto span:nth-child(2) {
  float: right;
}

.auto span:nth-child(2) a {
  font-size: 14px;
  color: #000000;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Common/Foot.vue